<template>
    <div class="home">
        <x-header>{{hasRole([SYSTEM_ROLE.MANAGER])?'已归档项目':'项目管理'}}</x-header>
        <x-content v-if="loading" style="height:100%;" :contentStyle="{alignItems:'center',justifyContent:'center',height:'100%'}">
            <bounce-loading></bounce-loading>
        </x-content>
        <x-content v-else  :contentStyle="{display:'block',width:'calc(100% - 32px)',padding:'16px'}">
            <div class="search_warp">
                <el-row class="list-control_warp">
                    <el-col :span="24">
                        <el-col :span="6">
                            <el-input alwaysShowClear clearable v-model="searchText" @keydown.enter.native="search" placeholder="输入项目名称">
                                <template slot="suffix">
                                    <i @click="search" style="cursor: pointer;" class="el-input__icon base-icon-search"></i>
                                </template>
                            </el-input>
                        </el-col>
                        <div style="display: flex; justify-content: flex-end;">
                            <el-button size="small" type="primary" @click="openDialog" icon="base-icon-plus" v-if="hasPermission([PERMISSION.GROUP_CREATE])">
                                    <span> 新增项目</span>
                            </el-button>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <!-- 
            <div style="display: flex; justify-content: space-between;">
                <el-radio-group @change="listGroup" v-model="groupRole" size="medium">
                    <el-radio-button label="">全部项目</el-radio-button>
                    <el-radio-button :label="GROUP_ROLE.LEADER+','+GROUP_ROLE.MANAGER">我管理的</el-radio-button>
                    <el-radio-button :label="GROUP_ROLE.USER">我加入的</el-radio-button>
                    <el-radio-button label="99">已归档项目</el-radio-button>

                </el-radio-group>
            </div>
            -->
            <x-card>
                           

                <el-table
                    :data="groupDataList"
                    stripe
                    style="width: 100%">
                    <el-table-column
                        prop="projectCode"
                        label="项目编号">
                    </el-table-column>
                    <el-table-column
                        label="项目名称">
				               	<template slot-scope="scope">
                                         {{scope.row.groupName}}
				               		<!--<router-link :to="`/manager/group/detail/${scope.row.id}`">{{scope.row.groupName}}</router-link> -->
				               	</template>
                    </el-table-column>
                    <!--<el-table-column
                        prop="topicHead"
                        label="创建人">
                    </el-table-column> -->
                    <el-table-column
                        label="负责人">
                        <template slot-scope="scope">
							{{scope.row.groupManagerList?scope.row.groupManagerList.join(","):""}}
						</template>
                    </el-table-column>
                    <!-- 
                    <el-table-column
                        prop="topicName"
                        label="所属课题">
                    </el-table-column>
                    -->
                     <el-table-column
                        label="当前模板">
                         <template slot-scope="scope">
                            {{scope.row.formTemplateId?formTemplateNameMap[scope.row.formTemplateId]:''}}
						             </template>
                    </el-table-column>
                    <el-table-column
                        prop="createTime"
                        label="创建时间">
                    </el-table-column>
                     <el-table-column
                        prop="archivingTime"
                        label="归档时间">
                    </el-table-column>
                    <el-table-column
                        label="项目成员">
                         <template slot-scope="scope">
                            <el-tooltip content="成员管理" placement="bottom" v-if="(scope.row.userRole&&(scope.row.userRole.includes('2')||scope.row.userRole.includes('1')||scope.row.userRole.includes('3')))||hasRole([SYSTEM_ROLE.MANAGER])">
                                <el-link type="primary"  style='color:#409EFF' @click="$router.push('/manager/groupUser/' + scope.row.id)" :underline="false">{{scope.row.countGroupUser}}</el-link>
                            </el-tooltip>
                            <span v-else>{{scope.row.countGroupUser}}</span>
                        </template>
                    </el-table-column>
                     <el-table-column
                        label="已提交实验">
                        <template slot-scope="scope" >
                            <el-tooltip content="查看项目下的实验" placement="bottom" v-if="(scope.row.userRole&&(scope.row.userRole.includes('1')||scope.row.userRole.includes('2')||scope.row.userRole.includes('3')))||hasRole([SYSTEM_ROLE.MANAGER])">
                           <el-link type="primary" style='color:#409EFF' @click="$router.push('/manager/experiment/' + scope.row.id+'_'+((scope.row.userRole&&(scope.row.userRole.includes('3')))||hasRole([SYSTEM_ROLE.MANAGER])?'5':'4'))" :underline="false">{{scope.row.countExperiment}}</el-link>
                            </el-tooltip>
                          <span v-else>{{scope.row.countExperiment}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        width="230"
                        label="操作">
                        <template slot-scope="scope">
                            <template v-if="scope.row.archivingStatus!=1">
                                <template v-if="scope.row.userRole&&(scope.row.userRole=='1'||scope.row.userRole.includes('2'))">
                                    <el-button   size="mini" @click="editFormTemplate(scope.row)"  class="btnInfo" >更换模板</el-button>
                                    <el-button  size="mini" @click="editProject(scope.row)" type="primary">重命名</el-button>
                                    <el-button  size="mini" @click="shareSet(scope.row.id)" type="success">分享设置</el-button>
                                    <el-button  size="mini" @click="archivingProject(scope.row.id)" type="primary">项目归档</el-button>
                                    <el-button v-if="scope.row.countExperiment==0"  size="mini" @click="dissolutionGroup(scope.row)" type="warning">删除项目</el-button>
                                </template>
<!--                                <template v-if="scope.row.userRole=='1'">-->
<!--                                    <el-button v-if="scope.row.topicHead == user.name" class="group_operate" size="mini" @click="transferGroup(scope.row)" type="warning">转让项目</el-button>-->
<!--                                </template>-->
                                <template>
                                    <el-button   size="mini"  @click="$router.push('/manager/experiment/edit/'+scope.row.id+'/'+scope.row.formTemplateId+'/1/0')" type="primary">新建实验</el-button>

                                    <el-button   size="mini" @click="exitProject(scope.row)" type="info">退出项目</el-button>
                                </template>
                                 <!--<el-button  size="mini" @click="$router.push('/manager/experiment/share/' + scope.row.id)"   class="btnInfo">分享给项目的实验</el-button>
                               <el-`button class="group_operate" size="mini" @click="$router.push('/manager/group/detail/' + scope.row.id)" type="success">项目应用</el-button> -->
                            </template>
                            <template v-else>
                            <svg t="1688546377180" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9029" data-spm-anchor-id="a313x.7781069.0.i40" width="50" height="50"><path d="M936.999 234.579C782.773 0.151 467.589-65.027 232.933 89.043c-234.657 154.07-299.9 468.951-145.68 703.379 154.221 234.422 469.42 299.606 704.067 145.537 234.646-154.07 299.9-468.952 145.679-703.38zM768.373 903.238c-215.487 141.477-504.865 81.556-646.477-133.635C-19.7 554.326 40.281 265.236 255.666 123.764 471.158-17.703 760.532 42.218 902.138 257.398c141.604 215.18 81.722 504.368-133.765 645.84z m108.641-629.372C744.54 72.574 473.844 16.626 272.354 148.867 70.865 281.109 14.76 551.65 147.228 752.936c132.372 201.298 403.176 257.344 604.659 125 201.495-132.344 257.595-402.778 125.127-604.07zM740.467 860.685c-191.95 125.993-449.843 72.712-575.96-119.06C38.389 549.861 91.718 292.221 283.672 166.227c191.956-125.994 449.849-72.718 575.966 119.05 126.216 191.766 72.79 449.408-119.171 575.408z m-349.048-530.57c60.479-39.683 133.368-45.637 196.425-22.519l21.737-14.289c-72.387-31.946-158.883-27.68-229.984 18.942-71.1 46.627-109.23 124.308-108.636 203.375l21.748-14.387c3.772-67.053 38.232-131.438 98.71-171.122z m253.125 384.626c71.096-46.627 109.231-124.313 108.636-203.375l-21.742 14.29c-3.768 67.069-38.231 131.45-98.709 171.133-60.474 39.688-133.364 45.627-196.42 22.524l-21.747 14.386c72.384 31.937 158.887 27.67 229.982-18.958zM326.868 293.408l14.796-39.089 41.71 1.986-32.574-26.09 14.797-39.089-34.954 22.92-32.674-26.095 11.023 40.277-34.952 22.915 41.801 1.986 11.027 40.279z m-40.216 41.274l-40.617-9.824-3.077-41.665-21.95 35.513-40.611-9.916 27.01 31.943-21.946 35.518 38.629-15.874 27.111 31.845-3.178-41.669 38.629-15.871z m150.647-98.813l29.888-29.168 37.043 19.349-18.473-37.401 29.888-29.168-41.406 6.05-18.473-37.499-7.052 41.171-41.405 6.055 37.037 19.44-7.047 41.171z m124.429-5.556l39.513-13.787 25.328 33.136-0.997-41.669 39.528-13.888-40.124-12.005-0.895-41.664-23.827 34.324-40.016-12.004 25.311 33.232-23.821 34.325zM191.222 454.819l-20.456-36.407-4.866 41.465-41.015 8.138 37.933 17.459-4.866 41.466 28.403-30.651 37.932 17.459-20.456-36.407 28.403-30.758-41.012 8.236z m506.055 278.682L682.48 772.58l-41.709-1.986 32.572 26.094-14.795 39.09 34.957-22.916 32.675 26.08-11.023-40.268 34.948-22.919-41.807-1.986-11.021-40.268z m141.412-82.846l-38.635 15.874-27.111-31.85 3.178 41.674-38.629 15.875 40.617 9.818 3.076 41.66 21.947-35.514 40.622 9.922-27.017-31.943 21.952-35.516z m-251.843 140.38l-29.888 29.168-37.042-19.35 18.473 37.408-29.888 29.163 41.409-6.06 18.469 37.505 7.047-41.162 41.41-6.064-37.032-19.435 7.042-41.173z m-124.423 5.553l-39.524 13.791-25.323-33.136 0.992 41.67-39.524 13.888 40.119 12.01 0.896 41.658 23.832-34.323 40.021 11.997-25.323-33.227 23.834-34.328zM861.332 541.43l4.866-41.472-28.407 30.656-37.934-17.459 20.457 36.411-28.403 30.744 41.019-8.225 20.451 36.408 4.867-41.467 41.014-8.133-37.93-17.463z" fill="#d81e06" p-id="9030" data-spm-anchor-id="a313x.7781069.0.i39" class=""></path><path d="M375.298 584.906l-23.565-36.422-72.389 46.838c-2.72 1.76-4.606 3.483-5.663 5.164l-6.729-4.436c2.442-0.863 5.122-2.242 8.045-4.133l72.691-47.033-0.489-8.045c-0.036-2.262 0.476-3.738 1.534-4.423 1.057-0.685 3.35-0.952 6.875-0.805l10.082 0.339c3.093 0.142 5.047 0.844 5.861 2.102 0.816 1.262-0.338 3.9-3.453 7.916l21.414 33.097c1.826 2.821 3.213 4.856 4.16 6.099l2.596 3.68c0.652 1.01 0.71 2.258 0.173 3.748-0.535 1.492-2.025 3.883-4.468 7.178-2.441 3.296-3.99 5.154-4.645 5.578-0.656 0.424-1.438-0.068-2.352-1.48l-6.159-9.521-62.716 40.579 31.583 48.813c1.955 3.022 3.978 4.606 6.075 4.751 2.095 0.146 7.721-2.424 16.881-7.707 9.158-5.282 17.844-10.58 26.057-15.895 8.21-5.312 15.744-10.4 22.602-15.266 6.855-4.865 10.867-7.998 12.036-9.396 1.167-1.396 1.841-3.119 2.019-5.164s-0.195-4.662-1.115-7.855c-0.921-3.188-2.475-7.188-4.653-11.996-2.183-4.806-5.281-11.195-9.298-19.174l4.08-2.641c5.826 9.666 10.959 16.887 15.404 21.654 4.445 4.772 8.701 6.986 12.766 6.641 2.334-0.367 3.828-0.048 4.48 0.961 0.65 1.006 0.856 4.089 0.622 9.246-0.239 5.154-1.651 9.322-4.241 12.498-2.59 3.177-8.883 8.139-18.877 14.894-9.995 6.753-22.449 14.954-37.359 24.601-14.911 9.648-25.297 15.796-31.157 18.445-5.864 2.648-10.981 3.96-15.356 3.934-4.379-0.027-8.717-3.365-13.02-10.014l-39.014-60.3c-4.434-6.851-8.234-12.394-11.405-16.632 7.964-3.15 13.921-5.326 17.864-6.521 3.944-1.191 6.145-1.436 6.6-0.732 0.587 0.907-0.498 3.539-3.254 7.895l6.16 9.521 62.717-40.581zM424.673 508.795c-2.935-4.534-5.643-8.497-8.125-11.895 4.111-1.374 9.105-2.709 14.982-4.013 5.877-1.299 9.107-1.497 9.694-0.591 0.587 0.907-0.517 3.624-3.308 8.143l37.549 58.032c3.26 5.039 5.591 8.533 6.996 10.48l3.92 5.396c0.391 0.605 0.244 1.594-0.44 2.965-0.685 1.375-2.079 3.525-4.183 6.459-2.104 2.935-3.533 4.643-4.289 5.132s-1.459 0.231-2.111-0.777l-4.587-7.752c-1.726-2.884-4.542-7.351-8.454-13.396l-37.644-58.183z m11.219-46.279c9.4-3.365 15.635-5.326 18.704-5.885 3.07-0.556 4.817-0.507 5.24 0.147 0.425 0.657 0.175 1.816-0.747 3.485-0.923 1.669-1.183 3.09-0.782 4.258 0.4 1.172 1.267 2.899 2.601 5.178 22.009 35.787 35.414 58.877 40.215 69.277 4.8 10.4 7.744 20.254 8.83 29.553 1.088 9.303 0.25 18.669-2.507 28.101-2.762 9.431-7.146 19.663-13.153 30.7l-3.076-1.44c5.513-16.001 7.91-29.526 7.197-40.567-0.712-11.043-3.618-22.491-8.715-34.345-5.096-11.852-16.02-30.725-32.774-56.619-5.998-9.268-13.01-19.883-21.033-31.843z m114.541 24.938l-38.536 24.934c-1.813 1.173-3.538 3.147-5.175 5.921l-6.826-4.587c2.442-0.864 5.121-2.243 8.045-4.134l40.047-25.912-23.564-36.42-42.013 27.183c-2.72 1.76-4.606 3.483-5.662 5.165l-7.12-5.04c2.442-0.864 5.121-2.242 8.045-4.133l41.861-27.086 0.285-9.832c-0.047-1.396 0.23-2.293 0.834-2.685 0.907-0.587 4.229-0.806 9.971-0.662 5.739 0.146 9.348 0.313 10.828 0.498 1.479 0.189 2.496 0.71 3.049 1.565 0.555 0.857-0.756 4.026-3.926 9.507l49.38 76.318c2.934 4.533 5.134 7.826 6.604 9.876l3.965 5.796c0.391 0.605 0.533 1.156 0.427 1.654-0.106 0.497-0.714 1.711-1.823 3.645-1.108 1.93-2.485 4-4.129 6.209-1.646 2.208-2.77 3.507-3.374 3.897-0.604 0.392-1.429-0.221-2.472-1.831l-8.115-12.543-49.719 32.17c-2.721 1.761-4.608 3.48-5.663 5.164l-6.925-4.738c2.441-0.863 5.121-2.24 8.045-4.133l51.23-33.147-27.574-42.619zM607.567 406.107l2.268-1.467 0.027-9.236c0.061-1.895 0.542-3.138 1.449-3.725 0.906-0.586 4.213-0.223 9.92 1.085 5.706 1.313 8.822 2.368 9.342 3.173 0.523 0.808-0.176 1.83-2.088 3.067l-17.984 11.636 10.756 16.624c8.244-1.616 14.883-2.233 19.922-1.849 5.037 0.386 8.421 1.915 10.146 4.583 1.729 2.67 2.403 5.702 2.023 9.09-0.379 3.391-1.25 5.525-2.609 6.405-1.359 0.879-2.627 1.023-3.801 0.422-1.173-0.599-2.83-1.777-4.969-3.538-6.287-5.079-12.247-8.656-17.877-10.73l44.393 68.611c0.717 1.106 0.852 2.199 0.405 3.275-0.45 1.075-1.724 2.97-3.823 5.69-2.102 2.716-3.656 4.402-4.662 5.054-0.506 0.326-1.018 0.084-1.538-0.722l-4.294-7.298a390.422 390.422 0 0 0-8.4-13.645l-30.02-46.396c1.648 8.511 2.527 16.663 2.636 24.451 0.11 7.792-0.781 18.729-2.671 32.815l-4.596 0.187c1.195-24.213-4.332-51.868-16.587-82.958l-12.392 8.018c-2.621 1.696-4.623 3.35-6.01 4.96l-6.48-4.383c2.443-0.863 5.121-2.242 8.045-4.134l17.229-11.147-12.125-18.739c-5.605-8.664-9.473-14.309-11.602-16.935 5.221-2.091 9.622-3.686 13.197-4.787 3.577-1.098 5.807-1.682 6.689-1.755 0.884-0.069 1.456 0.097 1.716 0.499 0.522 0.808-0.396 3.257-2.747 7.351l17.112 26.448z m1.584-35.327c21.944 1.667 35.135 5.925 39.566 12.776 1.695 2.621 2.436 5.643 2.223 9.067-0.215 3.428-1.732 6.052-4.552 7.876-1.208 0.782-2.333 0.866-3.374 0.253-1.039-0.613-3.435-3.208-7.182-7.787-3.749-4.577-7.653-8.234-11.708-10.971-4.058-2.734-9.179-5.457-15.365-8.174l0.392-3.04z m58.287 27.461l-30.801-47.604c-3.911-6.045-6.275-9.587-7.094-10.632 13.689-5.567 21.058-7.548 22.1-5.938 0.719 1.11-0.166 3.611-2.648 7.502l31.289 48.36 15.869-10.267-0.009-10.285c0.111-0.93 0.419-1.558 0.925-1.884 0.604-0.391 4.211-0.615 10.818-0.676 6.608-0.058 10.189 0.341 10.742 1.196 0.555 0.857-0.316 3.602-2.609 8.228l33.344 51.533c4.433 6.85 7.09 10.85 7.974 11.993l2.596 3.68c0.521 0.805 0.473 1.838-0.142 3.094-0.618 1.257-2.012 3.301-4.179 6.134-2.171 2.832-3.809 4.608-4.915 5.324-0.707 0.458-1.549-0.071-2.525-1.582l-6.846-10.579-56.973 36.863c-2.018 1.305-3.484 2.682-4.4 4.134l-6.668-5.334c2.173-0.836 4.32-1.939 6.437-3.308l58.183-37.646-17.601-27.202-48.964 31.681c-1.915 1.239-3.432 2.65-4.551 4.231l-6.518-5.432c2.075-0.769 4.22-1.872 6.437-3.306l50.173-32.463-16.133-24.936-50.777 32.854c-2.018 1.305-3.534 2.715-4.553 4.231l-6.027-4.676c2.075-0.77 4.22-1.872 6.437-3.307l21.609-13.981z m4.741-72.53c15.059-1.023 23.045-0.832 23.957 0.579 0.457 0.706 0.027 1.59-1.283 2.653-1.314 1.064-2.135 2.061-2.464 2.987-0.329 0.929-0.729 2.904-1.204 5.924-3.131 19.465-6.07 34.801-8.82 46.012l-2.941-0.24c-0.331-24.367-2.747-43.673-7.245-57.915z" p-id="9031" data-spm-anchor-id="a313x.7781069.0.i37" class="" fill="#d81e06"></path></svg>
                            </template>

                        </template>
                    </el-table-column>
                </el-table>
                <div class="page-warp">
                    <el-pagination
                        @current-change="listGroup"
                        :hide-on-single-page="total<pageSize"
                        background
                        layout="total,prev, pager, next"
                        :total="total"
                        :page-size="pageSize"
                        :current-page.sync="page"
                    ></el-pagination>
                </div>
            </x-card>
        </x-content>
        <app-dialog  ref="addDialog" dialogTitle="新增项目" originTitle staticDialog width="800px" class="templatePreviewdialog">
            <el-form ref="form" label-position="top" :rules="rules" :model="form">
				<el-form-item prop="groupName" >
					<el-input placeholder="请输入项目名称" v-model="form.groupName">
					</el-input>
				</el-form-item>
<!--                <el-form-item prop="projectCode" >-->
<!--                    <p style="line-height:0px;color:#409eff"><i class='el-icon-info'></i> 项目编号将作为项目实验编号前缀</p>-->
<!--					<el-input placeholder="请输入项目编号" v-model="form.projectCode">-->
<!--					</el-input>-->
<!--				</el-form-item>-->
				<el-form-item prop="topicHead" label="课题负责人(项目主名称)" hidden>
					<el-input disabled placeholder="课题负责人(项目主名称)" v-model="form.topicHead">
					</el-input>
				</el-form-item>
                <el-form-item>
                    <el-radio-group v-model="domainId" size="medium" @change="loadFormTemplateList">
                        <el-radio-button label="">全部学科领域</el-radio-button>
                        <el-radio-button v-for="typeData in domainTypeList" :key="typeData.id" :label="typeData.id">{{typeData.name}}</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item prop="formTemplateId" style="margin:20px 0px">
                    <el-empty v-if="formTemplateList.length==0" description="暂无模板"></el-empty>
                    <el-radio-group v-model="form.formTemplateId" style="width:100%">
                        <el-row  :gutter="10" style="margin-top: 40px;">
                            <el-col :span="8" v-for="(item,key) in formTemplateList"  :key="item.id" style="margin-bottom:10px">
                                <div class="templateThumbnail"  :style="form.formTemplateId==item.id?'border: 1px solid #8da7ff;':''">
                                    <el-tag v-if="item.domainId" class="domainTag" size="small" type="success">{{domainNameMap[item.domainId]}}</el-tag>
                                    <h4>{{item.name}}</h4>
                                        <p style="margin-bottom:5px;height:120px">
                                            <el-image v-if="item.fileStore" :src="baseShowUrl+item.fileStore"  class="templateImg" />
                                            <span v-else style="color:#dbdbdb">
                                                <i style="font-size:70px;font-weight: lighter;" class="el-icon-picture-outline"></i>
                                                <div>暂无预览图</div>
                                            </span>
                                        </p>
                                        <p class="option">
                                            <el-button type="primary" class="btnInfo"  size="mini" @click="previewTemplate(item.id)">预览</el-button>
                                            <el-radio-button :label="item.id"  :style="form.formTemplateId==item.id?'background-color:#67C23A':''">{{ form.formTemplateId==item.id?'已':'' }}选择此模板</el-radio-button>
                                        </p>
                                    </div>
                                </el-col>
                            </el-row>
                        </el-radio-group>
				</el-form-item>
                <!-- 
                    <el-select class="Width-100" v-model="form.researchDept" filterable allow-create clearable placeholder="请选择研究部">
                        <el-option
                            v-for="item in topicGroupArr"
                            :key="item"
                            :label="item"
                            :value="item">
                        </el-option>
                    </el-select>
				</el-form-item>
				<el-form-item prop="topicGroup" label="课题组">
					<el-select class="Width-100" v-model="form.topicGroup" filterable allow-create clearable placeholder="请选择课题组">
                        <el-option
                            v-for="item in topicGroupArr"
                            :key="item"
                            :label="item"
                            :value="item">
                        </el-option>
                    </el-select>
				</el-form-item>
				<el-form-item prop="topicName" label="课题名称">
					<el-input placeholder="课题名称" v-model="form.topicName">
					</el-input>
				</el-form-item>
				<el-form-item prop="topicSource" label="课题来源">
					<el-input placeholder="课题来源" v-model="form.topicSource">
					</el-input>
				</el-form-item>
                -->
            </el-form>
            <div class="save_btn_warp">
                <el-button type="primary" style="width:120px;" size="medium" :loading="saveLoading" @click="saveGroup">下一步</el-button>
            </div>
        </app-dialog>
        <app-dialog  ref="dissolutionDialog" dialogTitle="转让项目" originTitle staticDialog width="600px">
            <div style="display: flex;flex-direction: column;">
                <span style="margin-bottom: 20px;">请选择要转让的人：</span>
                <el-radio-group v-model="checkGroupLeader">
                    <el-radio v-for="item in dissolutionGroupUserList" :key="item.value" :label="item.value">{{item.label}}</el-radio>
                </el-radio-group>
            </div>
            <div class="save_btn_warp">
                <el-button type="primary" style="width:200px;" size="medium" :loading="saveLoading" @click="saveDissolutionGroup">确定</el-button>
            </div>
        </app-dialog>

      <app-dialog ref="additionDialog" dialogTitle="成员管理" @hide="hideProjectSet" :hideCloseButton="true" originTitle staticDialog width="800px">
        <GroupUserManager  ref="groupUserManager" :isShowHeader="true" />
        <div class="save_btn_warp">
          <el-button type="primary" style="width:120px;" size="medium" @click="nextStep">下一步</el-button>
        </div>
      </app-dialog>
        <app-dialog  ref="shareDialog" dialogTitle="分享设置" @hide="hideShareSet" originTitle staticDialog width="500px">
				<div style="display: flex;flex-direction: column;">
<!--					<template v-if="groupData.shareUser">-->
<!--						<span style="margin-bottom: 10px;">默认分享用户：-->
<!--						</span>-->
<!--						<el-checkbox-group -->
<!--							v-model="selectTableUser"-->
<!--							>-->
<!--							<el-checkbox v-for="group in groupUsers" :label="group" :key="'fhr'+group.id">{{group.userName}}</el-checkbox>-->
<!--						</el-checkbox-group>-->
<!--					</template>-->
<!--					<template v-else>-->
<!--						<span v-if="this.selectTableUser.length>0">默认分享用户：-->
<!--							{{this.selectTableUser.map(e => {return e.userName}).join("；")}}-->
<!--						</span>-->
<!--					</template> -->
<!--					<div style="margin-top:15px">-->
<!--						<span>默认分享项目</span>-->
<!--						<div style="display: flex;flex-direction: column;">-->
<!--							<el-checkbox v-model="defaultShareGroup"  style="margin-top:10px;">{{groupData.groupName}}</el-checkbox>-->
<!--						</div>-->
<!--					</div>-->

          <div style="margin-top:15px">
            <el-radio-group v-model="groupData.shareStatus">
             <el-radio style="margin-bottom: 15px;display: block"  :label="'0'" >不允许分享</el-radio>
             <el-radio style="margin-bottom: 15px;display: block" :label="'1'" >允许分享到项目内成员</el-radio>
             <el-radio style="margin-bottom: 15px;display: block" :label="'2'" >允许分享到所内成员</el-radio>
            </el-radio-group>
					</div>
					<div class="setTooltip">
						<i class="el-icon-info"></i> 设置仅对该项目下的实验有效
					</div>
				</div>
				<div class="save_btn_warp">
					<el-button type="primary" style="width:120px;" size="medium" @click="saveShareSet">确定</el-button>
				</div>
			</app-dialog>
            <app-dialog ref="projectDialog" dialogTitle="项目重命名" @hide="hideProjectSet" originTitle staticDialog width="500px">
                    <el-form ref="form"  :model="formItem">
                        <el-form-item prop="groupName" >
                            <el-input placeholder="请输入项目名称" v-model="formItem.groupName"></el-input>
                        </el-form-item>
                    </el-form>
            <div class="save_btn_warp">
                <el-button type="primary" style="width:120px;" size="medium" @click="saveData">保存</el-button>
            </div>
        </app-dialog>
        <app-dialog ref="formTemplateDialog" dialogTitle="模板选择" @hide="hideTemplateDialog" originTitle staticDialog width="800px" class="templatePreviewdialog">
            <el-form ref="formTemplate"  :model="formTemplateItem">
                <el-form-item >
                    <el-radio-group v-model="domainId" size="medium" @change="loadFormTemplateList">
                    <el-radio-button label="">全部学科领域</el-radio-button>
                    <el-radio-button v-for="typeData in domainTypeList" :key="typeData.id" :label="typeData.id">{{typeData.name}}</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item prop="formTemplateId" style="margin:20px 0px">
                    <el-empty v-if="formTemplateList.length==0" description="暂无模板"></el-empty>
                    <el-radio-group v-model="formTemplateItem.formTemplateId" style="width:100%;">
                        <el-row  :gutter="10" style="margin-top: 40px;">
                            <el-col :span="8" v-for="(item,key) in formTemplateList"  :key="item.id" style="margin-bottom:10px">
                                <div class="templateThumbnail" :style="formTemplateItem.formTemplateId==item.id?'border: 1px solid #8da7ff;':''">
                                    <el-tag v-if="item.domainId" class="domainTag" size="small" type="success">{{domainNameMap[item.domainId]}}</el-tag>
                                    <h4>{{item.name}}</h4>
                                        <p style="margin-bottom:5px;height:120px">
                                            <el-image v-if="item.fileStore" :src="baseShowUrl+item.fileStore"  class="templateImg" />
                                            <span v-else style="color:#dbdbdb">
                                                <i style="font-size:70px;font-weight: lighter;" class="el-icon-picture-outline"></i>
                                                <div>暂无预览图</div>
                                            </span>
                                        </p>
                                        <p class="option">
                                            <el-button type="primary" class="btnInfo"  size="mini" @click="previewTemplate(item.id)">预览</el-button>
                                            <el-radio-button :label="item.id" > 选择此模板</el-radio-button>
                                        </p>
                                    </div>
                                </el-col>
                            </el-row>
                        </el-radio-group>
				</el-form-item>
            </el-form>
            <div class="save_btn_warp">
                <el-button type="primary" style="width:120px;" size="medium" @click="saveTemplateDialog">保存</el-button>
            </div>
        </app-dialog>
        <AppDialog ref="previewTemplateDialog"  width="900px"  originTitle dialogTitle="模板预览"  class="templatePreviewdialog">
		<form-create :rule="preViewRule" :option="preViewOptions"></form-create>
		</AppDialog>
    </div>
</template>
<script>
    import { ListGroup,GetGroupById,SaveGroup,UpdateGroupData,DissolutionGroup,ArchivingProject,ExitProject,TransferGroup,GetDissolutionGroupUser} from "../../service/user"
    import {GetAllList,GetDomainList} from "@/service/formTemplate";
	import formCreate from '@form-create/element-ui'
	import XUpload from "@/components/base/XUpload";
	import {Detail} from "@/service/formTemplate";
  import GroupUserManager from './GroupUserManager.vue';
  import ProjectTypeManager from './ProjectTypeManager.vue';

    let codeData = [];
    export default {
        name:'GroupManager',
        components:{
        XUpload,GroupUserManager,ProjectTypeManager,
        formCreate: formCreate.$form()
		},
        data(){
            return {
                loading:false,
                saveLoading:false,
                savePermissionLoading:false,
                researchDeptArr:[],
                topicGroupArr:[],
                page:1,
                total:0,
                pageSize:10,
                searchText:"",
                groupDataList:[],
                form:{
                    groupName:'',
                    topicHead:'',
                    researchDept:'',
                    topicGroup:'',
                    topicName:'',
                    topicSource:'',
                },
                baseShowUrl:'https://file.scholarin.cn/files?fastdfspath=',
                rules:{
                    groupName:[{required:true,message:'请输入项目名称',trigger:'blur'}],
                    //projectCode:[{required:true,message:'请输入项目编号',trigger:'blur'}],

                    //topicHead:[{required:true,message:'请输入课题负责人(项目主名称)',trigger:'blur'}],
                    formTemplateId:[{required:true,message:'请选择模板',trigger:'change'}],
                },
                checkRoleId:'',
                checkGroupLeader:'',
                dissolutionGroupUserList:[],
                dissolutionGroupObj:{},
                dissolutionGroupUserMap:{},
                groupRole:"",
                groupData:{},
                shareAppointPeople:false,
                shareAddGroup:false,
                shareOtherGroup:false,
                defaultShareGroup:false,
                groupUsers:[],
                selectTableUser:[],
                formItem:{},
                formTemplateList:[],
                formTemplateNameMap:{},
                formTemplateItem:{},
                noEdit:false,
                emailToReviewUser:false,
                emailToReviewResult:false,
                shareStatus:"",
                preViewRule:{},
			    preViewOptions:{},
                templateItem:{},
                groupId:'',
                isCreate:'',
                domainId:"",
                domainTypeList:[],
                domainNameMap:{},

            }
        },
        created(){
            if(this.$route.params.type){
                this.groupRole = this.$route.params.type
            }else{
                this.groupRole=""
            }
            //用于其他页面点击顶部新建项目
            if(this.$route.query.create){
                this.isCreate=this.$route.query.create
                this.$router.push({ query: {} });
            }
            this.listGroup();
            this.loadFormTemplateDomain();
            this.loadFormTemplateList();
            this.loadFormTemplate();
        },
        mounted(){
            //用户本页面点击顶部新建项目
            this.$root.$on("toAddProject",() => {
                this.openDialog();
            })
        },
        watch:{
			'$route.params.type':{
				handler:function (newVal){
                    if(newVal){
                        this.groupRole = newVal
                    }else{
                        this.groupRole=""
                    }
                      this.listGroup();
				},
				immediate:true
			}
		},
        methods:{
            search() {
		        	this.page = 1;
		        	this.listGroup();
		        },
            nextStep(){
              this.shareSet(this.groupId);
            },
            nextStep1(){
              this.$refs['categoryDialog'].hide();
              this.shareSet(this.groupId);
            },
            openDialog(){
                this.form.topicHead = this.user.name
                this.$refs['addDialog'].show()
            },
            listGroup(page){
                this.loading = true;
                ListGroup(this.groupRole,this.searchText,this.page,this.pageSize).then(e => {
                    let data = this.APIParse(e);
                    this.groupDataList = data.records;
                    this.total = data.total || 0;
                    //判断是否是跳转过来新建项目的
                    if(this.isCreate){
                        this.openDialog();
                        this.isCreate='';
                    }
                }).catch(e => {
                    this.$message.error(e.message)
                }).finally(e => {
                    this.loading = false;
                })
            },
            saveGroup(){
                this.$refs['form'].validate(valid => {
                  if (valid) {
                    this.saveLoading = true;
                    SaveGroup(this.form).then(e => {
                      let data = this.APIParse(e);
                      if(data){
                        //this.$message.success("项目创建成功")
                        //this.listGroup();
                        this.groupId=data;
                        this.$root.$emit("loadProject")
                        this.$refs['form'].resetFields();
                        this.$refs['addDialog'].hide();
                        this.$refs['additionDialog'].show();
                        this.domainId="";
                        this.$nextTick(()=>{
                            setTimeout(() => {
                                this.$refs.groupUserManager.getUserData(data);
                            }, 200);
                        })
                      }
                    }).catch(e => {
                      this.$message.error(e.message)
                    }).finally(e => {
                      this.saveLoading = false;
                    })
                  } else {
                    setTimeout(() => {
                        document.getElementsByClassName("is-error")[0].scrollIntoView({
                            behavior: "smooth",
                             block: "center"
                         });
                    }, 0);
                    return false;
                  }
                })
            },
            dissolutionGroup(row){
                this.$confirm('您确定要删除该项目吗？删除后可在回收站还原', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    DissolutionGroup(row.id).then(e => {
                      let data = this.APIParse(e);
                      if(data){
                        this.$message.success("删除项目成功")
                        this.listGroup();
                        this.$root.$emit("loadProject")

                      }
                    }).catch(e => {
                      this.$message.error(e.message)
                    }).finally(e => {
                    })
                }).catch(() => {  
                });
                
            },
            archivingProject(id){
                this.$confirm('您确定要归档该项目吗？归档项目后不允许进行任何操作，也无法恢复', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    ArchivingProject(id).then(e => {
                        let data = this.APIParse(e);
                        if(data){
                            this.$message.success("项目归档成功")
                            this.listGroup();
                            this.$root.$emit("loadProject")

                        }
                    }).catch(e => {
                        this.$message.error(e.message)
                    }).finally(e => {
                    })
                }).catch(() => {  
                });
                
            },
            exitProject(row){
                this.$confirm('您确定要退出该项目吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                      if (row.groupManagerList.length>1||row.userRole=='3'){
                        ExitProject(row.id).then(e => {
                          let data = this.APIParse(e);
                          if(data){
                            this.$message.success("退出项目成功")
                            this.listGroup();
                            this.$root.$emit("loadProject")
                          }
                        }).catch(e => {
                          this.$message.error(e.message)
                        }).finally(e => {
                        })
                      }else {
                        this.$message.warning("您当前是项目唯一负责人，需先指定其他用户为项目负责人，再进行退出项目")
                      }
                }).catch(() => {  
                });
                
            },
            loadFormTemplateDomain(){
                GetDomainList().then(e => {
                    let data = this.APIParse(e);
                    this.domainTypeList=data
                    data.forEach(item => {
						this.$set(this.domainNameMap,item.id,item.name)
					})
                })
            },
            loadFormTemplateList(){
                GetAllList(this.domainId).then(e => {
                    let data = this.APIParse(e);
                    this.formTemplateList=data
                }).catch(e => {
                    this.$message.error(e.message)
                }).finally(e => {
                   
                })
            },
            loadFormTemplate(){
                 GetAllList().then(e => {
                    let data = this.APIParse(e);
                     data.forEach(item => {
                      this.$set(this.formTemplateNameMap,item.id,item.name)
                    })
                }).catch(e => {
                    this.$message.error(e.message)
                }).finally(e => {
                   
                })
            },
            transferGroup(row){
                this.dissolutionGroupUserMap = {};
                this.dissolutionGroupObj = row;
                if(row.countGroupUser==1){
                    this.$message.warning("项目成员不足")
                }else{
                    GetDissolutionGroupUser(row.id).then(item => {
                         let data = this.APIParse(item);
                         data.forEach(e => {
                            this.dissolutionGroupUserMap[e.userId] = e.userName;
                         });
                         this.dissolutionGroupUserList = data.map(e => {
                            return {"label":e.userName,"value":e.userId}
                         })
                         this.$refs['dissolutionDialog'].show()
                    })
                }
            },
            saveDissolutionGroup(){
                if(this.checkGroupLeader){
                    TransferGroup(this.dissolutionGroupObj.id,this.checkGroupLeader,this.dissolutionGroupUserMap[this.checkGroupLeader]).then(e => {
                        let data = this.APIParse(e);
                        if(data){
                            this.$message.success("转让项目成功")
                            this.$refs['dissolutionDialog'].hide()
                            this.listGroup();
                        } 
                    })
                }
            },
            shareSet(groupId){
               this.$refs['additionDialog'].hide()
                this.$nextTick(() => {
                        GetGroupById(groupId).then(e => {
                        let data = this.APIParse(e);
                        this.groupData = data;
                        this.$refs['shareDialog'].show()
                    })
			});
		},
		saveShareSet(){
      UpdateGroupData(this.groupData).then(e => {
				let data = this.APIParse(e);
				if(data){
					this.$message.success("设置成功")
          this.listGroup();
					this.hideShareSet()
				}
			}).catch(e => {
				this.$message.error(e.message)
			})
		},
		hideShareSet(){
			this.$refs['shareDialog'].hide()
			this.shareAppointPeople = false
			this.shareAddGroup =false
			this.shareOtherGroup = false
			this.defaultShareGroup = false
			this.selectTableUser = []
		},

        editProject(data){
            this.formItem = data;
            this.$refs.projectDialog.show();
        },
        hideTemplateDialog(){
            this.$refs.formTemplateDialog.hide();
        },
        editFormTemplate(data){
            this.formTemplateItem = data;
            this.$refs.formTemplateDialog.show();
        },
        saveData(){
                if(!this.formItem.groupName){
                    this.$message.error('请输入项目名称')
                    return
                }
                UpdateGroupData(this.formItem).then(e => {
                    let data = this.APIParse(e);
                    if(data){
                        this.$message.success('修改成功')
                        this.hideProjectSet()
                        this.listGroup();
                        this.$root.$emit("loadProject")
                    }else{
                        this.$message.error('修改失败')
                    }
                }).catch(e => {
                    this.$message.error(e.message)
                })
            },
             saveTemplateDialog(){
                if(!this.formTemplateItem.formTemplateId){
                    this.$message.error('请选择模板')
                    return
                }
                UpdateGroupData(this.formTemplateItem).then(e => {
                    let data = this.APIParse(e);
                    if(data){
                        this.$message.success('修改成功')
                        this.hideTemplateDialog()
                        this.listGroup();
                        this.domainId="";
                    }else{
                        this.$message.error('修改失败')
                    }
                }).catch(e => {
                    this.$message.error(e.message)
                })
            },
        hideProjectSet(){
            this.$refs['projectDialog'].hide()
            this.$refs['additionDialog'].hide()
            //this.$refs['formTemplate'].resetFields();
            this.formTemplateItem={}
        } ,
        previewTemplate(templateId){
            Detail(templateId).then(e => {
				let data = this.APIParse(e);
                this.templateItem=data
                this.preViewRule = formCreate.parseJson(data.rule);
				this.preViewOptions = JSON.parse(data.options);
				this.preViewOptions.submitBtn = false
				this.$refs.previewTemplateDialog.show();
            }).catch(ex => {
                this.$message.error('模板加载失败')
            })
         
        },
    }  
}
</script>
<style lang="scss" scoped>
.el-table td.el-table__cell div .base-button--mini{
    padding: 0px 8px;
    margin-bottom: 5px;
}
    .Width-100{width: 100%}
    .home{width: 100%;height: 100%;overflow: auto;}
    .search_warp{width:100%;margin: 16px 0px;}
    .save_btn_warp{width: 100%;margin-top: 32px;display: flex;align-items: center;justify-content: center;}
	.page-warp{width: 100%;text-align: right;margin-top: 8px;}
    .setTooltip{
        margin-top: 30px;
        color:#409eff
    }
    .base-button{
        margin-left: 0px;
        margin-right: 5px;
    }
.templateThumbnail{
	height: 200px;
	background-color: #fff;
	box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  padding: 10px;
  padding-top: 20px;
  border-radius: 5px;
  text-align: center;
  border:1px solid #fff;
	position: relative;
}
.templateThumbnail:hover{
  border:1px dashed #8da7ff;
  //transform: scale(1.02);
}
.templateThumbnail p{
  margin-top: 5px;
  margin-bottom: 10px;
}
.templateThumbnail .domainTag{
	position: absolute;
	top: 0px;
	right: 0px;
}
.templateThumbnail h4{
    line-height: 16px;
    height: 32px;
    margin: 5px 0px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
}
.templateThumbnail .templateImg{
    max-height:100px;
    max-width: 100%;
}
.templateThumbnail .option{
	position: absolute;
	margin: 0 auto;
	bottom: 10px;
	left: 17%;
}

</style>
<style >
.templatePreviewdialog .AppDialog__inner{
	max-height: 80vm !important;
	overflow-y: scroll;
}
.templatePreviewdialog .base-radio-group{
    font-size: 14px;
}
.templateThumbnail .option .base-radio-button__inner{
    border-radius: 3px !important;
    color: #FFFFFF;
    background-color: #2F3A91;
    border-color: #2F3A91;
    height: 28px;
    padding: 0 15px;
    font-size: 12px;
    border-radius: 3px;
    line-height: 24px;
}
.templateThumbnail .option .base-radio-button.is-active .base-radio-button__inner{
    background-color:#67C23A ;
    border-color:#67C23A ;
    box-shadow:none;

}
</style>